<template>
  <div class="controls">
    <!--  Time controls  -->
    <template v-if="playInfo.booleanIsFullGame">
      <div class="controls__time">
        <div
          v-for="(objectTimeButton, index) of arrayTimeButtons"
          :key="index"
          :class="objectTimeButton.arrayCssClasses"
          @click="onClickTimeButton(objectTimeButton)"
        >
          <template v-if="objectTimeButton.numberType === 1">
            <div class="text">
              {{ objectTimeButton.numberValue }}
            </div>
            <div class="img">
              <img :src="objectTimeButton.stringIcon" alt="" />
            </div>
          </template>
          <template v-else>
            <div v-if="objectTimeButton.numberType === 2">{{ playerSpeed }}x</div>
            <div v-else>
              <img v-show="isVideoPlayerPlaying" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_pause.svg" alt="" />
              <img
                v-show="!isVideoPlayerPlaying"
                src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_play_dark.svg"
                alt=""
              />
            </div>
          </template>
        </div>
      </div>
      <div class="h-separator" />
    </template>
    <!--  Main info  -->
    <div class="controls__main-info">
      {{ title }}
    </div>
    <div class="h-separator" />
    <!--  Play info and buttons  -->
    <template v-if="!playInfo.booleanIsFullGame">
      <div class="controls__play-info">
        <div role="button" class="controls__play-info__button-mobile" @click="onClickNextBack('back')">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_back_mobile.svg" alt="back" />
        </div>
        <div
          role="button"
          class="controls__play-info__button"
          :class="{ disabled: !isFromMexico && !getIsGSUser }"
          @click="onClickNextBack('back')"
        >
          <div class="controls__play-info__button__icon">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_back_2.png" alt="next" />
          </div>
          <div class="controls__play-info__button__text">
            Anterior
          </div>
        </div>
        <div class="controls__play-info__detail">
          <div class="controls__play-info__detail__v-separator" />
          <div class="controls__play-info__detail__text">
            <span class="controls__play-info__detail__text__category">
              {{ playInfo.mainCategoryName }}
            </span>
            <span> - </span>
            <span>{{ playInfo.playerShortName }}</span>
          </div>
          <div class="controls__play-info__detail__v-separator" />
        </div>
        <div
          role="button"
          class="controls__play-info__button"
          :class="{ disabled: !isFromMexico && !getIsGSUser }"
          @click="onClickNextBack('next')"
        >
          <div class="controls__play-info__button__text">Siguiente</div>
          <div class="controls__play-info__button__icon">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_next_2.png" alt="next" />
          </div>
        </div>
        <div role="button" class="controls__play-info__button-mobile" @click="onClickNextBack('next')">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_next_mobile.svg" alt="next" />
        </div>
      </div>
      <div class="h-separator" />
    </template>
    <!--  Options  -->
    <div class="controls__options">
      <div class="controls__options__game-container">
        <div v-if="playInfo.objectHomeTeam || playInfo.homeTeamLogo" class="controls__options__game">
          <div class="controls__options__game__team-logo">
            <img :src="playInfo.homeTeamLogo || playInfo.objectHomeTeam.logo" />
          </div>
          <div class="controls__options__game__team-name">
            {{ playInfo.homeTeamName || playInfo.objectHomeTeam.name }}
          </div>
          <div class="controls__options__game__score">
            <span>{{ `${playInfo.arrayScore[0]} - ${playInfo.arrayScore[1]}` }}</span>
          </div>
          <div class="controls__options__game__team-name">
            {{ playInfo.awayTeamName || playInfo.objectAwayTeam.name }}
          </div>
          <div class="controls__options__game__team-logo">
            <img :src="playInfo.awayTeamLogo || playInfo.objectAwayTeam.logo" />
          </div>
        </div>
      </div>
      <div class="controls__options__buttons">
        <div v-for="(objectOption, index) of arrayOptions" :key="index" class="controls__options__buttons__button">
          <div v-if="getIsGSUser || objectOption.numberId !== 2" class="controls__options__buttons__button__option">
            <a
              class="full-game-link"
              v-if="playInfo.booleanIsFullGame && objectOption.numberId === 2"
              :href="`https://golstatsbets.blob.core.windows.net/video-player/${playInfo.gameId}_1.mp4`"
              target="_blank"
              download
            >
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_download.svg" alt="" />
              <span>Descargar</span>
            </a>
            <OptionButton
              v-else
              :id="objectOption.numberId"
              :iconUrl="objectOption.stringIconUrl"
              :text="objectOption.stringText"
              :is-disabled="getIsDisabledOption(objectOption.numberId)"
              @click-option="onClickOption($event)"
            />
          </div>
          <div class="controls__options__buttons__button__v-separator" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MediaPlayerControls',
  components: {
    OptionButton: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerOptionButton'),
  },
  props: {
    playInfo: {
      type: Object,
      default: () => ({
        objectHomeTeam: {},
        objectAwayTeam: {},
      }),
    },
    title: {
      type: String,
      default: '',
    },
    isVideoPlayerPlaying: {
      type: Boolean,
      default: false,
    },
    isFromMexico: {
      type: Boolean,
      default: false,
    },
    playerSpeed: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      arrayOptions: [
        {
          numberId: 1,
          stringIconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_data.png',
          stringText: 'Datos',
        },
        {
          numberId: 2,
          stringIconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_download.svg',
          stringText: 'Descargar',
        },
        {
          numberId: 3,
          stringIconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_save_edit.png',
          stringText: 'Guardar / Editar',
        },
        {
          numberId: 4,
          stringIconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_plays.png',
          stringText: 'Jugadas',
        },
      ],
      arrayTimeButtons: [
        {
          arrayCssClasses: ['time-button', 'backwards'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_back_white.svg',
          stringType: 'time',
          numberValue: 60,
          numberType: 1,
          numberValueFactor: -1,
        },
        {
          arrayCssClasses: ['time-button', 'backwards'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_back_white.svg',
          stringType: 'time',
          numberValue: 10,
          numberType: 1,
          numberValueFactor: -1,
        },
        {
          arrayCssClasses: ['time-button', 'backwards'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_back_white.svg',
          stringType: 'time',
          numberValue: 5,
          numberType: 1,
          numberValueFactor: -1,
        },
        {
          arrayCssClasses: ['player-button'],
          stringIcon: '',
          stringType: 'player',
          numberValue: 1,
          numberType: 2,
          booleanIsPlayerSpeed: true,
        },
        {
          arrayCssClasses: ['player-button'],
          stringType: 'player',
          numberType: 3,
        },
        {
          arrayCssClasses: ['time-button'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_next_white.svg',
          stringType: 'time',
          numberValue: 5,
          numberType: 1,
          numberValueFactor: 1,
        },
        {
          arrayCssClasses: ['time-button'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_next_white.svg',
          stringType: 'time',
          numberValue: 10,
          numberType: 1,
          numberValueFactor: 1,
        },
        {
          arrayCssClasses: ['time-button'],
          stringIcon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_next_white.svg',
          stringType: 'time',
          numberValue: 60,
          numberType: 1,
          numberValueFactor: 1,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getIsGSUser', 'getIsB2CPremium']),
  },
  methods: {
    getIsDisabledOption(numberOptionId) {
      return (
        (!this.isFromMexico && !this.getIsGSUser) ||
        (numberOptionId === 3 && !this.getIsGSUser && !this.getIsB2CPremium) ||
        (this.playInfo.isPlaySeeker && [1, 3].includes(numberOptionId)) ||
        (this.playInfo.booleanIsFullGame && [3].includes(numberOptionId))
      );
    },
    onClickTimeButton(objectTimeButton) {
      this.$emit('click-time-button', objectTimeButton);
    },
    onClickOption(numberOptionId) {
      if (!this.getIsDisabledOption(numberOptionId)) {
        this.$emit('click-option', numberOptionId);
      }
    },
    onClickNextBack(stringType) {
      this.$emit('click-next-back', stringType);
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #132739;
$green: #cbee6b;

.controls {
  font-size: 1rem;
  width: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: $blue;
  color: white;

  &__time {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    column-gap: 9px;
    padding: 9px 9px;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &.time-button {
        border-radius: 6px;
        border: solid 1px rgba(255, 255, 255, 0.3);
        font-family: Roboto-Medium, sans-serif;
        font-size: 0.875em;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.83;
        letter-spacing: -0.14px;
        padding: 0.3em 0 0.2em;

        & .text {
          padding-top: 1px;
        }

        &.backwards {
          flex-direction: row-reverse;
        }

        & > div.img {
          height: 17px;
          width: 17px;

          & > img {
            height: 17px;
            width: 17px;
          }
        }
      }

      &.player-button {
        border-radius: 16px;
        background-color: #cbee6b;
        font-family: Roboto-Bold, sans-serif;
        font-size: 0.875em;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.83;
        letter-spacing: -0.14px;
        text-align: center;
        color: #132839;
      }
    }

    @media screen and (max-width: 600px) {
      column-gap: 3px;
      padding: 9px 3px;
      font-size: 0.75em;
    }
  }

  &__main-info {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 2.125rem;
    text-align: center;
    font-family: Roboto-Regular, sans-serif;
    font-size: 1.125em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: -0.18px;
  }

  &__play-info {
    min-height: 2.125rem;
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    padding: 0 8px;

    &__detail {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__v-separator {
        height: 20px;
        border-left: dashed 1px #506270;
        margin: 8px;
      }

      &__text {
        font-family: Roboto-Regular, sans-serif;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.47;
        letter-spacing: -0.15px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &__category {
          font-family: Roboto-Bold, sans-serif;
          font-weight: bold;
        }
      }
    }

    &__button-mobile {
      display: none;
      height: 25px;
      width: 25px;

      & > img {
        height: 25px;
        width: 25px;
      }
    }

    &__button {
      display: flex;
      justify-content: center;
      padding: 2px 12px;
      align-items: center;
      font-family: Roboto-Medium, sans-serif;
      font-size: 11px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: -0.22px;
      text-align: center;
      border-radius: 8px;
      background-color: $green;
      color: $blue;
      cursor: pointer;

      &__icon {
        width: 16px;
        height: 16px;

        & > img {
          width: 16px;
          height: 16px;
        }
      }

      & > div {
        margin: 0 4px;
      }
    }

    & > div {
      align-self: center;
    }
  }

  &__options {
    min-height: 44px;
    padding: 0 8px;
    display: grid;
    grid-template-columns: 1fr min-content;

    &__game-container {
      display: flex;
      width: 100%;
      align-items: center;
    }

    &__game {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(5, min-content);
      column-gap: 0.625em;

      &__team-logo {
        height: 24px;
        width: 24px;

        & > img {
          height: 24px;
          width: 24px;
        }
      }

      &__team-name {
        font-family: Roboto-Medium, sans-serif;
        font-size: 0.625em;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.57;
        letter-spacing: -0.14px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__score {
        white-space: nowrap;
        font-family: Roboto-Bold, sans-serif;
        font-size: 1.0625rem;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: -0.17px;
        text-align: center;
      }

      & > div {
        align-self: center;
      }
    }

    &__buttons {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &__button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        &__option {
          margin: 0.8em;
        }

        &__v-separator {
          height: 10px;
          border-left: dashed 1px #506270;
        }

        &:last-child {
          & .controls__options__buttons__button__v-separator {
            display: none;
          }
        }
      }
    }

    @media screen and (max-width: 645px) {
      grid-template-columns: 1fr;

      &__game-container {
        display: flex;
        justify-content: center;
        width: 100%;
        padding-top: 0.5em;
      }

      &__buttons {
        display: grid;
        grid-template-columns: repeat(4, 1fr);

        &__button {
          &__option {
            margin: 0.8em auto;
          }
        }
      }

      & > div {
        width: 100%;
        justify-self: center;
      }
    }
  }

  & > div {
    width: 100%;
  }

  @media screen and (max-width: 570px) {
    &__play-info {
      &__button {
        display: none;
      }

      &__button-mobile {
        display: block;
      }

      &__detail {
        justify-content: center;

        &__v-separator {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 430px) {
    &__play-info {
      &__detail {
        justify-content: center;

        &__text {
          font-size: 13px;
        }
      }
    }

    &__options {
      &__game-container {
        width: 100%;
      }

      &__game {
        width: 100%;
        grid-template-columns: min-content min-content 1fr min-content min-content;
        padding: 0 1em;
      }
    }
  }
}

.disabled {
  cursor: default;
  opacity: 0.6;
}

.h-separator {
  width: 100%;
  height: 1px;
  border-bottom: dashed 1px #506270;
}

a.full-game-link {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > img {
    height: 24px;
    width: 24px;
  }

  & > span {
    font-family: Avenir-Demi, sans-serif;
    font-size: 0.625em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0.3px;
    text-align: center;
    color: #fff;
    white-space: nowrap;
  }
}
</style>
